import React, { useState, useEffect } from "react";
import {
  Table,
  Modal,
  message,
  Upload,
  Button,
  Tag,
  Tooltip,
  Form,
  Row,
} from "antd";
import {
  DownloadOutlined,
  PlusOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import InspectionApi from "@api/inspectionnew";
import sysApi from "@api/sys";
import SearchForm from "@components/SearchForm";
import HandleButton from "@components/HandleButton";
import { connect } from "react-redux";
import moment from "moment";
import { getStationData, toolMouseTip } from "@utils/common";
import AddModel from "./add";
import download from "@utils/download";
import "../style.scss";
const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 17 },
};
const OrderCom = (props) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]); // 表格数据
  const [editVisible, setEditVisible] = useState(false);
  const [editTitle, setEditTitle] = useState("新增保养标准");
  const [rowParams, setRowParams] = useState({});
  const [uploadVisible, setUploadVisible] = useState(false);
  // 搜索相关参数
  const [searchParams, setSearchParams] = useState({
    pageNum: 1,
    pageSize: 10,
  });
  const [total, setTotal] = useState(0);
  const [inputList] = useState([
    {
      label: "名称:",
      name: "upkeepStandardName",
      message: "请输入名称",
      span: 8,
      labelCol: 6,
    },
  ]);
  const [selectList] = useState();
  const [stationData, setStationData] = useState();
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    getStationList();
  }, []);
  // 获取厂站列表
  const getStationList = () => {
    const data = getStationData(
      props.userInfo.stationIds ? props.userInfo.stationIds : '-1',
      props.userInfo.stationAliasName
    );
    setStationData(data);
  };

  useEffect(() => {
    getListByPages();
    return () => {};
  }, [searchParams]);

  const getListByPages = () => {
    setLoading(true);
    InspectionApi.upkeepStandard({ ...searchParams }).then((res) => {
      setLoading(false);
      if (res.status == 0 && res.data) {
        setData(res.data.data || []);
        setTotal(res.data.total);
      }
    });
  };

  // 分页
  const handleTableChange = (pagination) => {
    let params = {
      ...searchParams,
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
    };
    setSearchParams(params);
  };

  /**
   * 搜索
   * @param params
   */
  const search = (paramsObj) => {
    console.log(paramsObj, "paramsObj");
    let params = {
      ...paramsObj,
      pageNum: 1,
      pageSize: 10,
      stationId: paramsObj.stationId && paramsObj.stationId * 1,
    };
    setSearchParams(params);
  };

  const showEdit = async (id) => {
    const res = await InspectionApi.upkeepStandardGetInfo({ id });
    if (res.status !== "0") return;
    setEditTitle("编辑保养标准");
    const ary = [];
    const {
      upkeepStandardItemVOS,
      handleRoleId,
      stationId,
      upkeepStandardName,
      upkeepTemplateType,
    } = res.data;

    if (upkeepStandardItemVOS.length > 0) {
      upkeepStandardItemVOS.forEach((item) => {
        let index = item.period.indexOf("个");
        ary.push({
          grease: item.grease,
          itemContent: item.itemContent,
          oilMass: item.oilMass,
          period: item.period.substring(0, index),
          unit: item.period.substring(index),
        });
      });
    } else {
      ary.push({
        grease: null,
        itemContent: null,
        oilMass: null,
        period: 1,
        unit: "个周",
      });
    }
    const params = {
      id,
      handleRoleId,
      stationId,
      upkeepStandardName,
      upkeepTemplateType,
      upkeepStandardTemplateAddDTOList: [
        {
          deviceId:
            upkeepStandardItemVOS.length > 0
              ? upkeepStandardItemVOS[0].deviceId
              : undefined,
          upkeepTemplateId:
            upkeepStandardItemVOS.length > 0
              ? upkeepStandardItemVOS[0].upkeepTemplateId
              : undefined,
          upkeepStandardItemAddDTOList: ary,
        },
      ],
    };
    setRowParams({ ...params });
    setEditVisible(true);
  };

  const disenable = async (id) => {
    // 获取流程id
    const result = await sysApi.getFlowableId({
      dictType: "sw-flowable",
      dictKey: "upkeep_standard_status_disable",
    });
    if (result.status !== "0") return;
    const processId = result.data;
    const res = await InspectionApi.upkeepStandardDisenable({ id, processId });
    if (res.status !== "0") return;
    message.success("禁用成功");
    getListByPages();
  };

  const enable = async (id) => {
    const result = await sysApi.getFlowableId({
      dictType: "sw-flowable",
      dictKey: "upkeep_standard_status_enable",
    });
    if (result.status !== "0") return;
    const processId = result.data;
    const res = await InspectionApi.upkeepStandardEnable({ id, processId });
    if (res.status !== "0") return;
    message.success("启用成功");
    getListByPages();
  };

  const UploadPropsprops = {
    beforeUpload() {
      return false;
    },
    accpet: ".xls",
    action: "#",
    showUploadList: true,
    maxCount: 1,
    onChange(info) {
      const name = info.file.name;
      if (name.indexOf(".xls") < 0 && name.indexOf(".xlsx") < 0) {
        message.warning("所选文件的格式不正确！");
        setFileList([]);
        return false;
      }
      info.file.status = "done";
      setFileList([info.file]);
    },
    fileList,
    onRemove(file) {
      let f = fileList;
      const { uid } = file;
      const idx = fileList.findIndex((item) => item.uid == uid);
      f.splice(idx, 1);
      setFileList([...f]);
    },
  };

  const btnList = [
    {
      title: "新增",
      type: "primary",
      icon: <PlusOutlined />,
      visible:
        props.userInfo.btnResources.indexOf("upkeep:standard:add") !== -1
          ? true
          : false,
      onClick: () => {
        setEditTitle("新增保养标准");
        setRowParams({
          handleRoleId: null,
          stationId: undefined,
          upkeepStandardName: null,
          upkeepTemplateType: null,
          upkeepStandardTemplateAddDTOList: [
            {
              deviceId: null,
              upkeepStandardItemAddDTOList: [
                {
                  grease: null,
                  itemContent: null,
                  oilMass: null,
                  period: 1,
                  unit: "个周",
                },
              ],
              upkeepTemplateId: null,
            },
          ],
        });
        setEditVisible(true);
      },
    },
    {
      title: "批量导入",
      icon: <UploadOutlined />,
      style: { marginLeft: "10px" },
      type: "primary",
      visible:
        props.userInfo.btnResources.indexOf("upkeep:standard:batchImport") !==
        -1
          ? true
          : false,
      icon: <PlusOutlined />,
      onClick: () => {
        setUploadVisible(true);
      },
    },
    {
      title: "下载模板",
      style: { marginLeft: "10px" },
      type: "primary",
      visible: true,
      icon: <DownloadOutlined />,
      onClick: () => {
        InspectionApi.downloadUpkeepStandardTmp().then((res) => {
          download(res, "保养标准模板.xlsx");
        });
      },
    },
  ];

  const submit = () => {
    form.validateFields().then((values) => {
      if (!values) {
        return;
      }
      if (fileList.length == 0) return message.error("请上传文件！");
      let formData = new FormData();
      formData.append("file", fileList[0]);
      InspectionApi.upkeepStandardBatchImport(formData, {
        "Content-Type":
          "multipart/form-data; boundary=----WebKitFormBoundaryYmNa307cOmXILq7Z",
      }).then((res) => {
        if (res.status === "0") {
          message.success("上传成功");
          form.resetFields();
          setUploadVisible(false);
          getListByPages();
        }
      });
    });
  };

  const columns = [
    {
      title: "名称",
      dataIndex: "upkeepStandardName",
      align: "center",
      key: "upkeepStandardName",
      render: (_t) => toolMouseTip(_t, 20),
    },
    {
      title: "执行角色",
      dataIndex: "handleRoleName",
      align: "center",
      key: "handleRoleName",
    },
    {
      title: "状态",
      dataIndex: "status",
      align: "center",
      key: "status",
      render: (obj) => (
        <Tag color={obj ? "#87d068" : "#FF3819"}> {obj ? "启用" : "禁用"} </Tag>
      ),
    },
    {
      title: "审批状态",
      dataIndex: "approvalStatus",
      align: "center",
      key: "approvalStatus",
      render: (val) => {
        if (val == 1) {
          return <Tag color="#2D99FF">审批中</Tag>;
        } else if (val == 2) {
          return <Tag color="#87d068">通过</Tag>;
        } else if (val == 3) {
          return <Tag color="#FF3819">拒绝</Tag>;
        } else {
          return "-";
        }
      },
    },
    {
      title: "创建时间",
      dataIndex: "createAt",
      align: "center",
      key: "createAt",
      render: (obj) => {
        if (obj) {
          return moment(obj).format("YYYY-MM-DD HH:mm:ss");
        }
      },
    },
    {
      title: "操作",
      key: "operation",
      width: "200px",
      fixed: "right",
      render: (obj, record) => {
        return (
          <>
            {props.userInfo.btnResources.indexOf("upkeep:standard:edit") !==
              -1 && (
              <Button
                className="worningBtn"
                size="small"
                type="primary"
                onClick={() => showEdit(record.id)}
              >
                编辑
              </Button>
            )}
            {props.userInfo.btnResources.indexOf("upkeep:standard:disable") !==
              -1 &&
              record.status == 1 &&
              record.approvalStatus !== 1 && (
                <Button
                  className="deleteBtn"
                  size="small"
                  type="primary"
                  style={{ marginLeft: 10 }}
                  onClick={() => disenable(record.id)}
                >
                  禁用
                </Button>
              )}
            {props.userInfo.btnResources.indexOf("upkeep:standard:enable") !==
              -1 &&
              record.status !== 1 &&
              record.approvalStatus !== 1 && (
                <Button
                  className="success"
                  size="small"
                  type="primary"
                  style={{ marginLeft: 10 }}
                  onClick={() => enable(record.id)}
                >
                  启用
                </Button>
              )}
          </>
        );
      },
    },
  ];
  return (
    <div className="baseContent boundary">
      <div className="title">
        <div style={{ marginLeft: "24px" }}>
          <SearchForm
            span={6}
            inputList={inputList}
            selectList={selectList}
            onSearch={search}
          />
        </div>
        <HandleButton
          btnList={btnList}
          btnStyle={{ padding: "0 24px 20px", textAlign: "right" }}
        />
        <div>
          <Table
            className="Table"
            scroll={{ x: columns.length * 200 }}
            columns={columns}
            dataSource={data}
            rowKey={(record) => record.createAt}
            pagination={{
              current: searchParams.pageNum,
              pageSize: searchParams.pageSize,
              showQuickJumper: true,
              showSizeChanger: true,
              showTotal: (total) => `共${total}条数据`,
              total: total,
            }}
            onChange={handleTableChange}
            loading={loading}
          />
        </div>
        {uploadVisible && (
          <Modal
            title="批量导入"
            width={620}
            open={uploadVisible}
            footer={[
              <Row key={"btn"} span={24}>
                <Button
                  key={1}
                  onClick={() => {
                    setUploadVisible(false);
                  }}
                  className="abuttons"
                >
                  <i className="iconfont iconfanhui"></i>&nbsp;&nbsp;取消
                </Button>
                <Button
                  key={2}
                  loading={loading}
                  onClick={submit}
                  className="abuttons"
                  type="primary"
                >
                  <i className="iconfont iconbaocun"></i>&nbsp;&nbsp;保存
                </Button>
              </Row>,
            ]}
          >
            <Form
              {...layout}
              layout="horizontal"
              form={form}
              style={{ marginTop: "20px" }}
            >
              <Form.Item
                label="模版文件"
                name="file"
                rules={[{ required: true, message: "请选择文件!" }]}
              >
                <Upload {...UploadPropsprops}>
                  {
                    <div className="upload-clk-area">
                      <Button type="primary">上传文件</Button>
                    </div>
                  }
                </Upload>
              </Form.Item>
            </Form>
          </Modal>
        )}
        {editVisible && (
          <AddModel
            stationData={stationData}
            visible={editVisible}
            title={editTitle}
            formData={rowParams}
            cancel={(bool) => {
              setEditVisible(false);
              bool && getListByPages();
            }}
          />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};

export default connect(mapStateToProps)(OrderCom);
